import { useAuth } from '@/lib/useAuth'
import { Card, EmptyState } from '@/components/ui'

/**
 * Zatim jen potvrzeni, ze prihlaseni funguje a token projde na chraneny
 * endpoint. Vlastni prace s texty (cteni, slovnik, faze uceni) prijde dal —
 * viz docs/ANALYZA.md, baliky 3–5.
 */
export function TextsPage() {
  const { user } = useAuth()

  return (
    <div className="space-y-4">
      <Card>
        <h2 className="font-semibold">Přihlášení funguje</h2>
        <dl className="mt-3 grid gap-x-6 gap-y-1 text-sm sm:grid-cols-[8rem_1fr]">
          <dt className="text-slate-500">E-mail</dt>
          <dd>{user?.email}</dd>
          <dt className="text-slate-500">Jméno</dt>
          <dd>{user?.displayName ?? <span className="text-slate-400">nevyplněno</span>}</dd>
          <dt className="text-slate-500">Účet od</dt>
          <dd>{user ? new Date(user.createdAt).toLocaleDateString('cs-CZ') : '—'}</dd>
        </dl>
        <p className="mt-3 text-xs text-slate-400">
          Tahle data přišla z <code>GET /api/app/auth/me</code>, tedy přes ověřený token.
        </p>
      </Card>

      <EmptyState
        title="Zatím žádné texty"
        hint="Vkládání článků, slovník a fáze učení jsou další na řadě."
      />
    </div>
  )
}
